<template>
  <v-dialog :value="value" content-class="acq-dialog" max-width="400" @input="$emit('input', $event)">
    <v-card class="acq-dialog mdlg-scope">
      <div class="d-flex align-start pa-5 pb-3" style="gap: 12px">
        <span class="acq-avatar acq-avatar--sm tone-warn"><v-icon small style="color: inherit">mdi-alert-outline</v-icon></span>
        <div class="flex-grow-1">
          <div class="acq-section-title">{{ title }}</div>
          <div class="acq-tiny mt-1">{{ text }}</div>
        </div>
      </div>
      <div class="d-flex align-center pa-5 pt-2" style="gap: 8px">
        <v-spacer/>
        <button class="cta cta--ghost" type="button" @click="$emit('input', false)">Weiter bearbeiten</button>
        <button class="cta cta--danger" type="button" @click="$emit('confirm')">
          <v-icon class="cta__icon" small>mdi-delete-outline</v-icon>Verwerfen
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

/** Small in-app confirmation "Änderungen verwerfen?" for form dialogs that are closed with unsaved changes (emits confirm) */
export default Vue.extend({
  props: {
    value: {type: Boolean, required: true},
    title: {type: String, default: 'Änderungen verwerfen?'},
    text: {type: String, default: 'Es gibt Änderungen, die noch nicht gespeichert sind. Beim Schließen gehen sie verloren.'},
  },
});
</script>

<style src="@/components/acquisitionList/ui/acquisitionViews.css"></style>
<style src="./modern.css"></style>
<style src="./modernDialog.css"></style>
